import { css } from '@emotion/react';
export var embedCardStyles = css({
  '.ProseMirror': {
    ".embedCardView-content-wrap[layout^='wrap-']": {
      maxWidth: '100%'
    },
    ".embedCardView-content-wrap[layout='wrap-left']": {
      float: 'left'
    },
    ".embedCardView-content-wrap[layout='wrap-right']": {
      float: 'right'
    },
    ".embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']": {
      clear: 'both'
    }
  }
});
export var embedSpacingStyles = css({
  margin: "0 ".concat("var(--ds-space-150, 12px)")
});